<script>
    import { onMount } from 'svelte';
    import "./helpCenter.css";
    let emailBubble = "./images/email-bubble.svg";
    onMount(() => {
        window.scrollTo(0, 0);
    });
</script>
<div class="support-page relative">
    <div class="privacy-top-header">
        <h1 class="text-center flex flex-text-center items-center">
            Support Team
        </h1>
    </div>
    <div class="container">
        <div class="support-content-area">
            <h2 class="text-center">Need Some Help?</h2>
            <div class="support-card flex flex-text-center flex-wrap">
                <div class="card">
                    <div class="support-outer-content flex items-center flex-text-center column-direction">
                        <div class="box flex items-center flex-text-center">
                            <img src={emailBubble} alt="email" />
                        </div>
                        <h2>Support Request</h2>
                        <div class="support-inner-content">
                            <p class="text-center">
                                Mail us your questions with account setup, on project
                                funding or your project content. We will have them
                                answered.
                            </p>
                            <p class="text-center">
                                24/7 Live Support & FAQs coming soon.
                            </p>
                            <h3 class="text-center">
                                <a href="mailto:support@polinate.io">
                                    support@polinate.io
                                </a>
                            </h3>
                        </div>
                        <a href="mailto:support@polinate.io">
                            <button>GET Help !</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>